import React, { useState } from 'react';
import DataTable from 'react-data-table-component';
import { money as moneyFormat } from 'utils/format/money';
import { Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import columns from './Table/columns';
import { useContext } from '../Context';

const generateFilter = (invoices) => {
  const options = [];

  invoices.forEach((item) => {
    if (!options.some((option) => option.value === item.attributes.payment_information_label)) {
      options.push({
        value: item.attributes.payment_information_label,
        label: item.attributes.payment_information_label,
      });
    }
  });

  return options;
};

export default function Table({ adminView }) {
  const { state } = useContext();

  const [paymentMethod, setPaymentMethod] = useState(null);

  const invoices = (state.policy.attributes.invoices || [])
    .filter((invoice) => paymentMethod === null || invoice.attributes.payment_information_label === paymentMethod);

  return (
    <>
      {state.policy && (
        <>
          <Row>
            <Col md={4}>
              <Select
                isClearable
                isSearchable
                placeholder={
            invoices ? 'Filter by Payment Method' : 'Payment Method Loading ...'
                        }
                onChange={(option) => {
                  setPaymentMethod(option == null ? null : option.value);
                }}
                options={invoices
                  ? generateFilter(invoices)
                  : []}
              />
            </Col>
          </Row>
          <div className="datatable-style">
            <DataTable
              title=""
              columns={columns(adminView)}
              data={invoices}
              noDataComponent={
                <div className="mt20">No matching records found</div>
            }
              persistTableHead
              pagination
              paginationComponentOptions={{
                selectAllRowsItem: true,
                selectAllRowsItemText: 'All',
              }}
            />
            {invoices.length > 0 && (
              <div className="text-right font-18">
                <span className="green mr5">Total:</span>
                <span>
                  {moneyFormat(
                    invoices
                      .filter((item) => item.attributes.status === 'paid')
                      .reduce((a, b) => a + parseFloat(b.attributes.amount), 0),
                    state.policy.attributes.currency_title,
                  )}
                </span>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
}
